import { useEffect, useRef } from 'react'

import { useTranslation, Trans } from 'react-i18next'
import { Container, Grid } from '@mui/material'
import { useRouter } from 'next/router'

import FieldLogo from 'public/images/field-logo.svg'
import Button from '@/components/atoms/Button'

import { getLinkByLocale } from './utils'
import ComponentStyled from './styled'

const CropMap = (): JSX.Element => {
  const { t } = useTranslation()

  const videoRef = useRef<HTMLVideoElement>(null)
  const { locale } = useRouter()

  useEffect(() => {
    let playState = false

    if (videoRef?.current) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && videoRef.current) {
            videoRef.current.play()
            playState = true
          }
        })
      }, {})

      observer.observe(videoRef.current)

      const onVisibilityChange = () => {
        if ((!document.hidden || playState) && videoRef.current) {
          videoRef.current.play()
        }
      }

      document.addEventListener('visibilitychange', onVisibilityChange)
    }
  })

  const ctaLink = getLinkByLocale(locale)

  return (
    <ComponentStyled>
      <Container maxWidth='xl'>
        <Grid container spacing={4} justifyContent='center'>
          <Grid item>
            <p className='other-projects'>{t('Other Projects supporting biodiversity')}</p>
          </Grid>
        </Grid>
        <Grid container spacing={4} justifyContent='space-between' alignItems='center'>
          <Grid item xs={12} md={5}>
            <video muted playsInline className='video' ref={videoRef}>
              <source src='/videos/crop-fields-map.mp4' type='video/mp4' />
              Your browser does not support the video tag.
            </video>
          </Grid>
          <Grid item xs={12} md={6}>
            <FieldLogo className='field-logo' />
            <p className='map-title'>
              <Trans i18nKey='100 crops, <1>1 field.</1>'>
                100 crops, <p>1 field.</p>
              </Trans>
            </p>
            <p className='map-desc'>
              {t('To celebrate the 100 year anniversary of our company, we also launched the Field 100 Project:')}
            </p>
            <p className='map-secondary-desc'>
              {t(
                'An initiative to promote biodiversity by sowing, growing and harvesting 100 diverse crops in one field. From corn, oats and buckwheat to millet, sorghum, amaranth and quinoa.'
              )}
            </p>
            <a href={ctaLink} target='_blank' rel='noreferrer' className='discover-more'>
              <Button label={t('Discover more')} size='medium' />
            </a>
          </Grid>
        </Grid>
      </Container>
    </ComponentStyled>
  )
}

export default CropMap
